import React, {useCallback} from 'react';

import {useAccountStatuses} from 'src/hooks/dictionaries';

import {FlatButton} from '@pb/kit-component-button';
import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import {Group} from '@pb/kit-component-group';


import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';

type Props = {
    selectedStatuses?: string[],
    onSelect: (accountStatuses: string[]) => void,
};

export const AccountStatusFilter = ({selectedStatuses, onSelect}: Props) => {
    const {accountStatuses} = useAccountStatuses();

    const changeAccountStatus = useCallback((statuses: ChangeTreeType) => {
        onSelect(statuses.checkedIdsList);
    }, [onSelect]);

    const selectAll = useCallback(() => {
        onSelect(accountStatuses.map(({code}) => code));
    }, [accountStatuses, onSelect]);

    const deselectAll = useCallback(() => {
        onSelect([]);
    }, [onSelect]);

    return (
        <Group direction="v" alignItems="start">
            <FlatButton onClick={selectedStatuses?.length ? deselectAll : selectAll}>
                {selectedStatuses?.length ? 'Deselect All' : 'Select All'}
            </FlatButton>
            <CheckBoxTree
                checkedIdsList={selectedStatuses || []}
                data={accountStatuses.map(({code, description}) => ({
                    id: code,
                    caption: description,
                }))}
                onChange={changeAccountStatus}
            />
        </Group>
    );
};
